
<template>
  <iframe :src="html"></iframe>
  <!-- <web-view :src="html" ></web-view> -->
</template>

<script>
  export default {
    name:"YlPay",
    data() {
      return {
        html:'../../static/pay.html',
        content:localStorage.getItem('payYlHTML')
      }
    },
  }
</script>

<style>
  iframe{
    width: 98vw;
    height: 98vh;
    border: none;
  }
</style>



// WEBPACK FOOTER //
// src/components/YlPay.vue